import { Fragment } from 'react'
import { Box } from '@mui/material'

import { capitalize } from '@ecm/data/String'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import BreadcrumbJsonLd from '@ecm/ui/seo/BreadcrumbJsonLd'

export type BreadCrumb = {
  description: string
  href: string
  position: number
}

const homeList: BreadCrumb[] = [
  {
    description: 'Home',
    href: '/',
    position: 1,
  },
]

type BreadcrumbsProps = {
  breadCrumbList: BreadCrumb[]
  truncateText?: boolean
}

const Breadcrumbs = ({ breadCrumbList, truncateText }: BreadcrumbsProps) => {
  const fullList = homeList.concat(breadCrumbList)

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={fullList.map(breadCrumb => ({
          item: breadCrumb.href,
          name: breadCrumb.description,
          position: breadCrumb.position,
        }))}
      />

      <Box
        mb="1em"
        width="100%"
        sx={{
          '& span': {
            color: Color.saint.lighter,
            fontWeight: 700,
            px: '0.3em',
          },
          ...(truncateText
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }
            : {
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'wrap',
              }),
        }}
      >
        {fullList.map(({ href, description, position }: BreadCrumb, i, arr) => (
          <Fragment key={position}>
            <Anchor
              href={href}
              prefetch={false}
              variant="p3"
              disabled={i === arr.length - 1}
              display="inline"
              color={Color.saint.lighter}
              sx={{ '&:hover': { color: Color.saint.normal } }}
            >
              {capitalize(description)}
            </Anchor>
            {i < arr.length - 1 && <span>|</span>}
          </Fragment>
        ))}
      </Box>
    </>
  )
}

export default Breadcrumbs
